"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailPageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.DetailPageContainer = styled_components_1.default.div `
  background-color: ${(props) => props.backgroundColor};
`;
